import React, {useState, useEffect} from "react";
import styled from "styled-components"
import { useNavigate } from "react-router-dom";
import LOGO from "../../img/LOGO.png"
import CantUseImg from "../../img/CantUseImg.png"

import axios from "axios";
import { useCookies } from 'react-cookie';

const Styled={
    Wrap:styled.div`
        width:100%;
        height:100vh;
        display:flex;
        justify-content:center;
        align-items:center;
        flex-direction:column;
    `,
        AllWrap:styled.div`
            width:320px;
            height:464px;
            display:flex;
            justify-content:space-between;
            align-items:center;
            flex-direction:column;
            margin-bottom:100px;
        `,
            Header:styled.div`
                width:182px;
                height:74px;
                display:flex;
                justify-content:space-between;
                align-items:center;
                flex-direction:column;
            `,
                HeaderText:styled.p`
                    font-size:20px;
                    font-weight:400;
                    color:#111111;
                    margin:0px;
                    font-family:'PreFont';
                    letter-spacing: -0.5px;
                `,
                LogoImg:styled.img`
                    width:182px;
                    height:40px;
                `,
            SecondText:styled.p`
                font-size:20px;
                font-weight:600;
                color:#111111;
                margin:0px;
                font-family:'PreFont';
                letter-spacing: -0.5px;
            `,
            MainImg:styled.img`
                width:167px;
                height:167px;
            `,
            Footer:styled.div`
                width:320px;
                height:42px;
                display:flex;
                justify-content:space-between;
                align-items:center;
                flex-direction:column;
            `,
                FooterTitle:styled.p`
                    font-size:16px;
                    font-weight:600;
                    color:#111111;
                    margin:0px;
                    font-family:'PreFont';
                    letter-spacing: -0.4px;
                `,
                FooterSubText:styled.p`
                    font-size:14px;
                    font-weight:400;
                    color:#767676;
                    margin:0px;
                    font-family:'PreFont';
                    letter-spacing: -0.35px;
                `,
}

const CantUse=()=>{
    return(
        <Styled.Wrap>
            <Styled.AllWrap>
                <Styled.Header>
                    <Styled.HeaderText>당신의 간편한 메뉴판</Styled.HeaderText>
                    <Styled.LogoImg src={LOGO}/>
                </Styled.Header>
                <Styled.SecondText>메뉴판 서비스를 이용할 수 없어요</Styled.SecondText>
                <Styled.MainImg src={CantUseImg}/>
                <Styled.Footer>
                    <Styled.FooterTitle>현재 위치가 매장 근처가 아니에요</Styled.FooterTitle>
                    <Styled.FooterSubText>위치정보 확인이 되지 않으면 서비스 이용이 불가능해요</Styled.FooterSubText>
                </Styled.Footer>
            </Styled.AllWrap>
        </Styled.Wrap>
    )
}
export default CantUse